function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "loyalty-tier-2_svg__linear-gradient",
  x1: 247.55,
  x2: 247.55,
  y1: 578.23,
  y2: -490.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#650360"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#954293"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loyalty-tier-2_svg__linear-gradient-2",
  x1: -156.13,
  x2: 475.05,
  y1: 270.72,
  y2: 270.72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#954293"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#650360"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loyalty-tier-2_svg__linear-gradient-3",
  x1: 247.45,
  x2: 247.45,
  y1: 453.31,
  y2: -72.37,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#954293"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#a95ba6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#c178bc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#d28ccb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#dc99d5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#df9dd8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loyalty-tier-2_svg__linear-gradient-4",
  x1: 9075.38,
  x2: 9218.3,
  y1: -3612.38,
  y2: -3612.38,
  gradientTransform: "scale(-1 1) rotate(47 96.652 -12362.783)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#f6cbf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#df9dd8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-2_svg__linear-gradient-4",
  id: "loyalty-tier-2_svg__linear-gradient-5",
  x1: 9028.26,
  x2: 9175.42,
  y1: -3622.37,
  y2: -3622.37
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loyalty-tier-2_svg__linear-gradient-6",
  x1: 180.36,
  x2: 317.32,
  y1: 285.98,
  y2: 223.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#df9dd8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#842a7e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#650360"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loyalty-tier-2_svg__linear-gradient-7",
  x1: 965.63,
  x2: 990.92,
  y1: -794.05,
  y2: -794.05,
  gradientTransform: "rotate(-6.36 8777.446 6940.826)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#9eefe1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1c988a"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-2_svg__linear-gradient-4",
  id: "loyalty-tier-2_svg__linear-gradient-8",
  x1: -2456.99,
  x2: -2314.07,
  y1: 8835.95,
  y2: 8835.95,
  gradientTransform: "rotate(47.19 8811.14 7697.116)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-2_svg__linear-gradient-4",
  id: "loyalty-tier-2_svg__linear-gradient-9",
  x1: -2504.11,
  x2: -2356.95,
  y1: 8825.96,
  y2: 8825.96,
  gradientTransform: "rotate(47.19 8811.14 7697.116)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-2_svg__linear-gradient-6",
  id: "loyalty-tier-2_svg__linear-gradient-10",
  x1: 17222.94,
  x2: 17359.9,
  y1: 285.98,
  y2: 223.95,
  gradientTransform: "matrix(-1 0 0 1 17537.49 0)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-2_svg__linear-gradient-7",
  id: "loyalty-tier-2_svg__linear-gradient-11",
  x1: 17830.49,
  x2: 17855.78,
  y1: 1085.54,
  y2: 1085.54,
  gradientTransform: "scale(-1 1) rotate(-6.3 74.244 165268.021)"
}), /*#__PURE__*/React.createElement("style", null, ".loyalty-tier-2_svg__cls-5{fill:#650360;opacity:.5}.loyalty-tier-2_svg__cls-11{fill:#954293}.loyalty-tier-2_svg__cls-13{fill:#cb3974}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "loyalty-tier-2_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "loyalty-tier-2_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M435.09 520.6l-178.71-83.74a20.84 20.84 0 00-17.67 0L60 520.6c-13.64 6.39-29.39-3.4-29.39-18.27V50.56a20.4 20.4 0 0120.57-20.24h392.74a20.4 20.4 0 0120.55 20.24v451.77c0 14.87-15.75 24.67-29.38 18.27z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415.68 487.07l-160.31-76.3a18.46 18.46 0 00-15.84 0l-160.31 76.3a18.44 18.44 0 01-26.36-16.64V71a18.43 18.43 0 0118.43-18.44h352.32A18.43 18.43 0 01442 71v399.43a18.44 18.44 0 01-26.32 16.64z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.09 52.56v415.06l30.06-14.31V52.56h-30.06z",
  className: "loyalty-tier-2_svg__cls-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.09 52.56h-15.03v422.21l15.03-7.15V52.56zm254.72 0v415.06l15.04 7.15V52.56h-15.04z",
  opacity: 0.3,
  fill: "#954293"
}), /*#__PURE__*/React.createElement("path", {
  d: "M374.81 52.56h-30.06v400.75l30.06 14.31V52.56z",
  className: "loyalty-tier-2_svg__cls-5"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M150.15 52.56v400.75l89.38-42.54a18.46 18.46 0 0115.84 0l89.38 42.54V52.56z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient-3)",
  opacity: 0.3
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.13 334.78l87.41-45.44a8.92 8.92 0 003.8-12L150 180.4 54.65 230c-2.23 1.16-1.9 5.17.58 7.21l40.85 33.41a10 10 0 013.61 7l3.88 52.63c.23 3.11 3.33 5.68 5.56 4.53z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.47 300.55l-3.66-6.72-1.16-2.23L79 197.92a8.92 8.92 0 013.81-12l90.64-48 54 103.84-91 48.19z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient-5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.33 290.41l56.35-29.79 6.87 13.23L142 303.24a7.23 7.23 0 01-9.75-3.08 7.23 7.23 0 013.08-9.75z",
  className: "loyalty-tier-2_svg__cls-11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M313 392.52c3.8-1.73 5.87-5.43 4.5-8L180.69 124.35c-1.3-2.47-5.18-3-8.69-1.17-3.52 1.83-5.32 5.33-4 7.81l136.8 260.12c1.2 2.34 4.79 2.95 8.2 1.41z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient-6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.22 234.35l17.35-.86a3.7 3.7 0 002.63-6.09L176 214.16a3.74 3.74 0 01-.75-3.36l4.52-16.8a3.69 3.69 0 00-5-4.38l-16.07 6.58a3.68 3.68 0 01-3.42-.32l-14.54-9.5a3.7 3.7 0 00-5.71 3.37l1.3 17.31a3.69 3.69 0 01-1.37 3.16l-13.52 10.89a3.69 3.69 0 001.44 6.47l16.87 4.12a3.66 3.66 0 012.58 2.27l6.17 16.23a3.7 3.7 0 006.61.63l9.12-14.77a3.69 3.69 0 012.99-1.71z",
  className: "loyalty-tier-2_svg__cls-13"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169.45,
  cy: 117.52,
  r: 12.65,
  fill: "url(#loyalty-tier-2_svg__linear-gradient-7)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M385.77 334.78l-87.41-45.44a8.92 8.92 0 01-3.8-12l50.36-96.9L440.25 230c2.23 1.16 1.9 5.17-.58 7.21l-40.85 33.41a10 10 0 00-3.61 7l-3.88 52.63c-.23 3.11-3.33 5.68-5.56 4.53z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient-8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362.43 300.55l3.66-6.72 1.16-2.23 48.69-93.68a8.92 8.92 0 00-3.81-12l-90.64-48-54 103.84 91 48.19z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient-9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.57 290.41l-56.35-29.79-6.87 13.23 56.55 29.39a7.23 7.23 0 009.75-3.08 7.23 7.23 0 00-3.08-9.75z",
  className: "loyalty-tier-2_svg__cls-11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.91 392.52c-3.8-1.73-5.87-5.43-4.5-8l136.8-260.12c1.3-2.47 5.18-3 8.69-1.17 3.52 1.83 5.32 5.33 4 7.81L190.11 391.11c-1.23 2.34-4.8 2.95-8.2 1.41z",
  fill: "url(#loyalty-tier-2_svg__linear-gradient-10)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.68 234.35l-17.35-.86a3.7 3.7 0 01-2.63-6.09l11.23-13.24a3.74 3.74 0 00.75-3.36l-4.55-16.8a3.69 3.69 0 015-4.38l16.07 6.58a3.68 3.68 0 003.42-.32l14.54-9.5a3.7 3.7 0 015.71 3.37l-1.3 17.31a3.69 3.69 0 001.37 3.16l13.52 10.89a3.69 3.69 0 01-1.44 6.47l-16.87 4.12a3.66 3.66 0 00-2.58 2.27l-6.17 16.23a3.7 3.7 0 01-6.61.63l-9.12-14.77a3.69 3.69 0 00-2.99-1.71z",
  className: "loyalty-tier-2_svg__cls-13"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 325.45,
  cy: 117.52,
  r: 12.65,
  fill: "url(#loyalty-tier-2_svg__linear-gradient-11)"
})));

function SvgLoyaltyTier2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 514 572"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref2));
}

export default SvgLoyaltyTier2;